import Styles from './CommonQuizQuestion.module.scss';

// Module imports.
import { Box } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import DoNotDisturbOnIcon from '@mui/icons-material/DoNotDisturbOn';

// Components import.
import { useTranslation } from 'components/lib';

export const CommonQuizQuestion = ({ question, questionNumber, onAnswerSelect, selectedAnswers, Results }) => {

    const { t } = useTranslation();
    const { id, question: questionText, options, selectedOption, isCorrect, isAttempted, inference, imageUrl, questionType } = question;
    const handleAnswerSelect = (selectedOption, index) => {
        onAnswerSelect(questionNumber - 1, id, selectedOption);
    };
    const headerIcon = !isAttempted ? <DoNotDisturbOnIcon fontSize='small' sx={{ mr: '2px' }} />
        : isCorrect ? <CheckCircleIcon fontSize='small' sx={{ mr: '2px' }} />
            : <CancelIcon fontSize='small' sx={{ mr: '2px' }} />;

    const headerText = !isAttempted ?
        t('CommonQuiz.QuizCommon.CCQuestion.helper.notAttempt') :
        isCorrect ? t('CommonQuiz.QuizCommon.CCQuestion.helper.correct') :
            t('CommonQuiz.QuizCommon.CCQuestion.helper.incorrect');

    const inferenceText = !isAttempted ?
        t('CommonQuiz.QuizCommon.CCQuestion.inference.notAttempt') :
        isCorrect ?
            t('CommonQuiz.QuizCommon.CCQuestion.inference.correct') :
            inference;

    return (
        <Box sx={{
            padding: 2,
            width: '85%'
        }}>
            <Box width={'100%'} height={'100%'}>
                {/* <Typography> */}
                <div className={Styles.question}>
                    {questionText.includes('|||') ? (
                        <>
                            <span className={Styles.questionText}>
                                Q{questionNumber}: {questionText.split('|||')[0]}
                            </span>
                            <div
                                className={Styles.codeText}
                                style={{
                                    whiteSpace: 'pre',
                                    border: '1px solid #ccc',
                                    borderRadius: '4px',
                                    padding: '8px',
                                    backgroundColor: 'black',
                                    spellCheck: false,
                                    overflow: 'auto' // Add this line
                                }}
                                readOnly
                            >
                                {questionText.split('|||')[1]}
                            </div>
                        </>
                    ) : (
                        <>
                            {questionType === "textAndImage" && imageUrl ? (
                                <div>
                                    <span className={Styles.questionText}>
                                        Q{questionNumber}: {questionText}
                                    </span>
                                    <img
                                        src={imageUrl}
                                        alt="question-image"
                                        className={Styles.questionImage}
                                    />
                                </div>
                            ) : (
                                <>
                                    <span className={Styles.questionText}>
                                        Q{questionNumber}: {questionText}
                                    </span>


                                </>
                            )}

                        </>
                    )}

                    {!Results ? <div className={Styles.gridOptions}>
                        {options.map((option, index) => (
                            <div key={questionNumber + index} style={{ display: 'flex' }}>
                                <label key={questionNumber + index} style={{ display: 'flex', cursor: 'pointer', }}><input
                                    type="radio"
                                    value={option}
                                    name={questionText}
                                    style={{ cursor: 'pointer', }}
                                    onClick={() => handleAnswerSelect(option)}
                                />
                                    <div
                                        unselectable="on"
                                        key={questionNumber + index}
                                        className={Styles.gridOption}
                                        onClick={() => handleAnswerSelect(option)}
                                        style={{
                                            cursor: 'pointer',
                                            backgroundColor: selectedAnswers[questionNumber - 1].selectedOption === option ? '#4986d6' : '#fff',
                                            color: selectedAnswers[questionNumber - 1].selectedOption === option ? '#ffffff' : '#000000'
                                        }}
                                    >
                                        {option}
                                    </div>
                                </label>
                            </div>
                        ))}
                    </div> : <div className={Styles.gridOptions}>
                        {options.map((option, index) => {
                            const isSelected = (option === selectedOption);
                            return (
                                <label key={questionNumber + index} style={{ display: 'flex' }}><input
                                    type="radio"
                                    value={questionNumber + index}
                                    name={questionText}
                                    disabled
                                    checked={isSelected}
                                />
                                    <div
                                        key={questionNumber + index}
                                        className={Styles.gridOption}
                                        style={{
                                            backgroundColor: isSelected && isCorrect ? '#18af89' : isSelected ? '#dc6262' : '#fff',
                                            color: isSelected && isCorrect ? '#fff' : isSelected ? '#fff' : '#000'
                                        }}
                                    >
                                        {option}
                                    </div>
                                </label>
                            )
                        })}
                    </div>}
                </div>
                {Results &&
                    <div id='inferenceContainer'
                        className={Styles.inferenceContainer}
                        style={{
                            backgroundColor: !isAttempted ? '#f5f5f5' : isCorrect ? '#f4faf8' : '#fef4f5',
                        }}
                    >
                        <h3>
                            {headerIcon}{headerText}
                        </h3>
                        <span>{inferenceText}</span>
                    </div>}
                {/* </Typography> */}
            </Box>
        </Box>
    );
};